// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3l1TL","legacyBtn":"MutateMid_legacyBtn__2VPKj"};